import React, {Fragment, useEffect, useState} from 'react';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import Recepisse from '../../components/RecepisseDepot/index'
import Input, {InputF, InputT} from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
// import Update from '../Update';
const Erasmus = ({props}) => {
    const [InputVisible, SetInputVisible] = useState({
        'communication5':false,
        'justificatif':false,
        'diplome':false,
        'publication2':false,
        'publication3':false,
        'publication4':false,
        'publication5':false,
        'publication6':false,
        'publication7':false,
        'publication8':false,
        'publication9':false,
        'publication10':false,
        'communication2':false,
        'communication3':false,
        'communication4':false,
        'justificatif2':false,
        'justificatif1':false,
        'justificatif3':false,
        'justificatif4':false,
        'justificatif5':false,
        'justificatif6':false,
        'justificatif7':false,
        'justificatif8':false,
        'diplome2':false,
        'diplome3':false,
        'diplome4':false,
        'diplome5':false,
        'diplome6':false,
    })
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    
    const removeFile = (fieldName,state) => {
        console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        const updatedFiles = { ...selectedFiles };
        updatedFiles[fieldName] = null;
        setSelectedFiles(updatedFiles);
        console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState('');
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false)
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        "publication10" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv":false,
        "copie_carte_id" : false,
        "demande" : false,
        "lettre_motivation" : false,
        "copie_diplome" : false,
        "recommandation1" : false,
        "recommandation2" : false,
        "resume_these" : false,
        "publication_scientifique" : false,
        "attestation_travail" : false,
        "justificatif1" : false,
        "justificatif2" : false,
        "justificatif3" : false,
        "justificatif4" : false,
        "justificatif5" : false,
        "justificatif6" : false,
        "communication" : false,
        "diplome2" : false,
        "diplome3" : false,
        "diplome4" : false,
        "diplome5" : false,
        "diplome6" : false,
        "justificatif7" : false,
        "justificatif8" : false,
        "communication2" : false,
        "communication3" : false,
        "communication4" : false,
        "communication5" : false,
        "publication2" : false,
        "publication3" : false,
        "publication4" : false,
        "publication5" : false,
        "publication6" : false,
        "publication7" : false,
        "publication8" : false,
        "publication9" : false,
        "publication10" : false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        const file = event.target.files[0];
        const elements = document.getElementsByName(key)
        if (file?.size < maxFileSize){
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: file
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: true
            }));
            for (var i = 0; i < elements.length; i++) {
                var element1 = elements[i];
                element1.style.border = ""; // Applique une bordure rouge
            }
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                element.style.border = "2px solid #BC0C0C";
                element.style.transition ='border 0.5s ease-in-out;' // Applique une bordure rouge
            }

        }
    };
      useEffect(() => {
        const fetchNationalities = async () => {
            try {
              const response = await fetch('https://restcountries.com/v3.1/all');
              if (!response.ok) {
                throw new Error('Unable to fetch nationalities.');
              }
              const data = await response.json();
              let nationalities = data.map(country => country.name.common);
              nationalities = nationalities.sort()
              setNationalities(nationalities)
              return nationalities;
            } catch (error) {
              console.error('Error fetching nationalities:', error);
              return [];
            }
          };
          fetchNationalities()
      },[dataForm.type_poste]) 
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
    }
    const handleNextStep = () => {
        if (step === 1) {
           if (!dataForm.email || !dataForm.civilite || !dataForm.prenom|| !dataForm.nom || !dataForm.date_naissance || !dataForm.lieu_naissance || !dataForm.telephone || !dataForm.address) {
                setErrors(true)
           } else if (!valid.isValidPhoneNumber) {
            setMessageAlerte('Format du numéro incorrect')
        }  
           else {
                setErrors(false)
                setStep(step + 1)
           }
            
        } else if (step === 2) {
                if (dataForm.type_poste && dataForm.poste && dataForm.annee_experience  && dataForm.diplome) {
                    setErrors(false);
                    setStep(step + 1);
                   } else {
                        setErrors(true);
                }   
            
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9","publication10"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                    }
                }
            }
            for (let key in dataForm) {
                if (dataForm.hasOwnProperty(key)) {
                      if( dataForm[key] !== null) {
                        if (key === 'pays') {
                            if (dataForm['type_poste'] === 'PATS') {
                                if (dataForm['pays'] !== 'senegal') {
                                    dataForm['pays'] = 'SENEGAL'
                                }
                            }
                        }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
        //  for (let pair of formData.entries()) {
        //         console.log(pair[0] + ':' + pair[1]);
        //       }
            if (!valid.isValidPhoneNumber) {
                setMessageAlerte('Incorrect')
                setShow(true);
            
            }
            else if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else {
                setComplete(true)
                setSubmitted(true);
                const response = await axios.post(
                    'https://depot.uam.sn/api/v1/recrutement/',
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    setDeppotSuccess2(true)
                } else {
                    setSubmitted(false);
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                }
            } else {
                console.error('Error uploading files');
                console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
       console.error('Error', error);
    }
};
    const calculateProgress = () => {
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, votre candidature a deja été enregistrée' /> : null }
    {depotsuccess ? <Recepisse  dataPerson={data} title='Academic title' university='University'/>  : null}
    {/* {update ? <Update /> : null} */}
    <div>
        <div className='ml-2 mt-2' style={{display:'flex','justifyContent':'right'}}>
            {/* <Button variant='success' className=' p-2' onClick={handleUpdate}>Modifier son dossier </Button> */}
            {/* <Button variant='success' className=' p-1 '>Supprimer  son dossier </Button> */}
        </div>
    </div>
      <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            <div className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
            <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div>
        </div>
        <div id='nameModule' className=''>
                    <p> {step===1 ? 'Personal data' : 'Informations Complémentaires' }</p>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} label="E-mail" name='email' onChange={handleChange} />
                        <Form.Group>
                            <div className='d-inline'>
                                <Form.Check
                                inline
                                        type="radio"
                                        label="Male"
                                        value='Monsieur'
                                        required
                                        checked = {dataForm.civilite === 'Monsieur'}
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='d-inline'>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Female"
                                        value='Madame'
                                        checked = {dataForm.civilite === 'Madame'}
                                        required
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="First name " name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Family name" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date of birth" name='date_naissance' onChange={handleChange} />
                                {/* {older ? <span style={{color:'red'}}>Le concours  est ouvert aux bacheliers âgés de 22 ans au maximum en 2023.. </span>: null} */}
                                <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Place of birth" name='lieu_naissance' onChange={handleChange} />
                            </div> 
                            <InputT type='number' value={dataForm.telephone || ''} label="Phone number"  name='telephone' onChange={handleChange} />
                            {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null}
                            <Input type='text' value={dataForm.address || ''} label="Adress" name='address' onChange={handleChange} />
                            
                    </div>
                )}
                {/* terminaison de step 1 */}
                {/* step 2 */}
                {step === 2 && (
                    <div className='mb-3'>
                        <Form.Group id='serie'>
                        <Input  value={dataForm.type_poste || ''} type='text' label="Academic title" name='type_poste' onChange={handleChange} />
                        </Form.Group>
                        <Input  value={dataForm.poste || ''} type='text' label="University:" name='poste' onChange={handleChange} />
                        <Input  value={dataForm.diplome || ''} type='text' label="Faculty/School" name='diplome' onChange={handleChange} />
                        <Input  value={dataForm.annee_experience || ''} type='text' label="Department/Programme" name='annee_experience' onChange={handleChange} />
                        <Form.Group id=''>
                    <Form.Label className='fw-medium'>Type of Mobilty <span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='ecole_postulee' required value={dataForm.ecole_postulee} onChange={handleChange}>
                        <option value="" >--- Select ---</option>
                        <option>Student</option>
                        <option >Teachning</option>
                    </Form.Select>
                </Form.Group>
                        <div className='mb-3'>
                            {dataForm?.ecole_postulee ? <>
                                {dataForm?.ecole_postulee ==='Student' ? 
                                    <><InputF required={true} className="rounded-left mb-2" label="ICM-Application-Student-22" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                                        {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </> : 
                                    <><InputF required={true} id="copie_carte" className="rounded-left mb-2" label="ICM-Application-Staff-22" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
                                        {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                                    </>}
                            </> : null}
                    <InputF required={true} className="rounded-left mb-2" label="ICM-LearningAgreement-Study" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
                    {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="StaffMobilityAgreement-Teaching22-Incoming" message={<span style={{color:'red'}}>*</span>} type='file' name='lettre_motivation' onChange={(e) => handleFileChange(e,"lettre_motivation")} />
                    {!selectedFiles["lettre_motivation"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null}
                    <InputF required={true}  className="rounded-left mb-2" label="Photo" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
                    {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuiller le réduire . </span>: null} 

                </div>
                    </div>
                    
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuiler remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 2 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 2 && 
                <Button  variant="primary" type='submit' size="md"
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default Erasmus